import { Configuration } from './configuration';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface EnvironmentEndpoint {
  endpoint: string;
  type: string;
}

type environments =
  | 'submissionEndpoint'
  | 'submissionEndpointNew'
  | 'permissionsEndpoint'
  | 'permissionsEndpointOld'
  | 'updEndpoint'
  | 'updEndpointDevProd'
  | 'contentView'
  | 'endpointProfile'
  | 'endpointProfileWorkflow'
  | 'pushNotificationEndpoint'
  | 'pushNotificationEndpointNew'
  | 'tlsEndpoint'
  | 'tlsEndpointNew'
  | 'aapiEndpoint'
  | 'preferenceEndpoint'
  | 'ebxEndpoint'
  | 'ebxEndpointNew'
  | 'gegatewayEndpoint'
  | 'gegatewayEndpointNew'
  | 'reggieEndpoint'
  | 'reggieRecordEndpoint'
  | 'uwfDashboardEndpoint'
  | 'vmsApiEndpoint'
  | 'vmsApiEndpointNew'
  | 'taxonomySolrEndpoint'
  | 'tagfinderSolrEndpoint'
  | 'taggingServiceEndpoint'
  | 'contentCatalogViacomcbsEndpoint'
  | 'asperaNodeEndpoint'
  | 'umtsEndpoint'
  | 'umtsTransformationEndpoint'
  | 'dynamicFormsEndpoint'
  | 'vmsAudioTemplatesEndPoint'
  | 'vmsAudioTemplatesEndPointNew'
  | 'musicImportEndpoint'
  | 'vmsContentSecurityTemplatesEndPoint'
  | 'imageCleanupToolEndpoint'
  | 'ptsxEndpoint'
  | 'ptsxEndpointNew'
  | 'onboarding'
  | 'onboarding_v2'
  | 'sanitization'
  | 'sanitization_v2'
  | 'governance'
  | 'assets'
  | 'assetsElasticSearch'
  | 'assetsElasticSearchNew'
  | 'supplyChainApi'
  | 'fulfillmentApi'
  | 'parityToolApi'
  | 'assets_v2'
  | 'assetsElasticSearch_V2'
  | 'assetsElasticSearchNew_V2'
  | 'assetsParentLookup'
  | 'assetsParentLookup_v2'
  | 'assetsDirectParentLookup'
  | 'assetsDirectParentLookup_v2'
  | 'assetsDetails'
  | 'assetsDetails_v2'
  | 'sendEmail'
  | 'fileCreationApi'
  | 'programsApi'
  | 'templatesApi'
  | 'schedulesApi'
  | 'configsApi'
  | 'allConfigsApi'
  | 'accessApi'
  | 'omcApi'
  | 'omcGraphqlApi'
  | 'mipGraphqlApi'
  | 'authHelperUserTypeApi'
  | 'authHelperUserTokenApi'
  | 'authHelperSetUsersOidApi'
  | 'authHelperMembersInGroupApi'
  | 'vidispineApi'
  | 'fabric'
  | 'validate'
  | 'triggerReverseNotificationApi'
  | 'triggerReverseNotificationApiKey'
  | 'c3Api'
  | 'c3Ws'
  | 'fulfillmentGraphQlApi';

const environmentEndpoints: { [key: string]: EnvironmentEndpoint } = {
  gegatewayEndpoint: { endpoint: '/gegateway', type: 'gatewaysUrls.global-entry' },
  gegatewayEndpointNew: { endpoint: '/gegateway', type: 'gatewaysUrls.global-entry-new' },
  submissionEndpoint: { endpoint: '/gegateway/api', type: 'gatewaysUrls.global-entry' },
  submissionEndpointNew: { endpoint: '/gegateway/api', type: 'gatewaysUrls.global-entry-new' },
  dynamicFormsEndpoint: { endpoint: '/forms-api/api', type: 'gatewaysUrls.content-platform' },
  permissionsEndpoint: { endpoint: '/permissions/api', type: 'gatewaysUrls.content-platform-new' },
  permissionsEndpointOld: { endpoint: '/permissions/api', type: 'gatewaysUrls.content-platform' },
  updEndpoint: { endpoint: '/upd/api/v1', type: 'gatewaysUrls.content-platform' },
  updEndpointDevProd: { endpoint: '/upd/api/v1', type: 'gatewaysUrls.content-platform-new' },
  contentView: { endpoint: '/content-view', type: 'gatewaysUrls.content-view' },
  endpointProfile: { endpoint: '/endpoint-profile/api', type: 'gatewaysUrls.content-platform' },
  endpointProfileWorkflow: {
    endpoint: '/workflow-config-service/api',
    type: 'gatewaysUrls.content-platform',
  },
  pushNotificationEndpoint: { endpoint: '/gegateway/ws', type: 'gatewaysUrls.global-entry' },
  pushNotificationEndpointNew: { endpoint: '/gegateway/ws', type: 'gatewaysUrls.global-entry-new' },
  tlsEndpoint: { endpoint: '/gegateway/tls/api', type: 'gatewaysUrls.global-entry' },
  tlsEndpointNew: { endpoint: '/gegateway/tls/api', type: 'gatewaysUrls.global-entry-new' },
  aapiEndpoint: { endpoint: '/aapi/v1', type: 'gatewaysUrls.content-platform' },
  ebxEndpoint: { endpoint: '/ebx', type: 'gatewaysUrls.content-platform' },
  ebxEndpointNew: { endpoint: '/ebx', type: 'gatewaysUrls.content-platform-new' },
  preferenceEndpoint: { endpoint: '/preferences/api/v1', type: 'gatewaysUrls.content-platform' },
  reggieEndpoint: { endpoint: '/reggie', type: 'gatewaysUrls.content-platform' },
  reggieRecordEndpoint: { endpoint: '/reggie-record', type: 'gatewaysUrls.content-platform' },
  uwfDashboardEndpoint: { endpoint: '/uwfdashboard', type: 'gatewaysUrls.content-platform' },
  vmsApiEndpoint: { endpoint: '/gegateway/vms', type: 'gatewaysUrls.global-entry' },
  vmsApiEndpointNew: { endpoint: '/gegateway/vms', type: 'gatewaysUrls.global-entry-new' },
  taxonomySolrEndpoint: { endpoint: '/tt/taxonomy-solr', type: 'gatewaysUrls.content-platform' },
  tagfinderSolrEndpoint: { endpoint: '/tt/tagfinder-solr', type: 'gatewaysUrls.content-platform' },
  taggingServiceEndpoint: { endpoint: '/tt/tagging/api', type: 'gatewaysUrls.content-platform' },
  contentCatalogViacomcbsEndpoint: { endpoint: '', type: 'gatewaysUrls.catalog-viacomcbs' },
  asperaNodeEndpoint: { endpoint: '/gegateway/aspera', type: 'gatewaysUrls.global-entry' },
  asperaNodeEndpointNew: { endpoint: '/gegateway/aspera', type: 'gatewaysUrls.global-entry-new' },
  umtsEndpoint: { endpoint: '/umts/api/umtstorage/api/v1', type: 'gatewaysUrls.content-platform' },
  umtsTransformationEndpoint: {
    endpoint: '/umts/api/umtapi/api/v1',
    type: 'gatewaysUrls.content-platform',
  },
  vmsAudioTemplatesEndPoint: {
    endpoint: '/gegateway/vms/api/asfm/admin/audio/template',
    type: 'gatewaysUrls.global-entry',
  },
  vmsAudioTemplatesEndPointNew: {
    endpoint: '/gegateway/vms/api/asfm/admin/audio/template',
    type: 'gatewaysUrls.global-entry-new',
  },
  musicImportEndpoint: { endpoint: '/music-import/api', type: 'gatewaysUrls.content-platform' },
  vmsContentSecurityTemplatesEndPoint: {
    endpoint: '/gegateway/vms/ContentSecurityTemplates',
    type: 'gatewaysUrls.global-entry',
  },
  imageCleanupToolEndpoint: { endpoint: '/image-cleanup', type: 'gatewaysUrls.content-platform' },
  ptsxEndpoint: { endpoint: '/gegateway/ptsx', type: 'gatewaysUrls.global-entry' },
  ptsxEndpointNew: { endpoint: '/gegateway/ptsx', type: 'gatewaysUrls.global-entry-new' },

  // mdw endpoints
  onboarding: { endpoint: '/api/onboarding', type: 'api' },
  sanitization: { endpoint: '/api/sanitization/normalize', type: 'api' },
  governance: { endpoint: '/api/governance-tickets', type: 'api' },
  assets: { endpoint: '/api/updates', type: 'api' },
  assetsElasticSearch: { endpoint: '/search', type: 'api' },
  assetsElasticSearchNew: { endpoint: '/search_new', type: 'api' },

  // pgo endpoints
  sendEmail: { endpoint: '/api/reports/communication/sendemail', type: 'api.email-api' },
  supplyChainApi: { endpoint: '/api/', type: 'api.supply-chain-api' },
  fulfillmentApi: { endpoint: '', type: 'api.fulfillment-api' },
  parityToolApi: { endpoint: '', type: 'api.parity-tool-api' },

  assetsDirectParentLookup: { endpoint: '/search/details/direct_parent_uuid', type: 'api' },
  assetsParentLookup: { endpoint: '/search/details/parent_uuid', type: 'api' },
  assetsDetails: { endpoint: '/search/details', type: 'api' },
  // mdw endpoints v2
  onboarding_v2: { endpoint: '/onboarding', type: 'api_v2' },
  sanitization_v2: { endpoint: '/sanitizer/normalize', type: 'api_v2' },
  assets_v2: { endpoint: '/updates', type: 'api_v2' },
  assetsElasticSearch_V2: { endpoint: '/search', type: 'api_v2' },
  assetsElasticSearchNew_V2: { endpoint: '/search_new', type: 'api_v2' },
  assetsDirectParentLookup_v2: { endpoint: '/search/details/direct_parent_uuid', type: 'api_v2' },
  assetsParentLookup_v2: { endpoint: '/search/details/parent_uuid', type: 'api_v2' },
  assetsDetails_v2: { endpoint: '/search/details', type: 'api_v2' },

  // syndication
  fileCreationApi: { endpoint: '/filecreation', type: 'api.syndication-api' },
  programsApi: { endpoint: '/programs', type: 'api.syndication-api' },
  commercialsApi: { endpoint: '/commercials', type: 'api.syndication-api' },
  graphicsApi: { endpoint: '/graphics', type: 'api.syndication-api' },
  programsETLApi: { endpoint: '/etl/programs', type: 'api.syndication-api' },
  commercialsETLApi: { endpoint: '/etl/commercials', type: 'api.syndication-api' },
  graphicsETLApi: { endpoint: '/etl/graphics', type: 'api.syndication-api' },
  templatesApi: { endpoint: '/templates', type: 'api.syndication-api' },
  schedulesApi: { endpoint: '/schedules', type: 'api.syndication-api' },
  allConfigsApi: { endpoint: '/allconfig', type: 'api.syndication-api' },
  configsApi: { endpoint: '/config', type: 'api.syndication-api' },
  accessApi: { endpoint: '/access', type: 'api.syndication-api' },
  pdfImageApi: { endpoint: '/logos', type: 'api.syndication-api' },

  // order management console
  omcApi: { endpoint: '', type: 'api.omc-api' },
  omcGraphqlApi: { endpoint: '', type: 'api.omc-graphql-api' },

  // Media Ingest portal
  mipGraphqlApi: { endpoint: '', type: 'api.mip-graphql-api' },

  // auth helper api
  authHelperUserTokenApi: { endpoint: '/user-token', type: 'authHelper.auth-helper-url' },
  authHelperUserTypeApi: { endpoint: '/user-type', type: 'authHelper.auth-helper-url' },
  authHelperMembersInGroupApi: { endpoint: '/members-in-group', type: 'authHelper.auth-helper-url' },
  authHelperSetUsersOidApi: { endpoint: '/oid', type: 'authHelper.auth-helper-url' },


  // central repository
  vidispineApi: { endpoint: '/', type: 'api.vidispine' },
  fabric: { endpoint: '/discovery/', type: 'api.fabric' },
  validate: { endpoint: '/validate', type: 'api.validate' },
  triggerReverseNotificationApi: { endpoint: '/', type: 'api.trigger-reverse-notification-api' },
  triggerReverseNotificationApiKey: { endpoint: '', type: 'api.trigger-reverse-notification-api-key' },

  // C3 Linear Monitoring
  c3Api: { endpoint: '', type: 'api.c3-api' },
  c3Ws: { endpoint: '', type: 'api.c3-ws' },

  // Fulfillment 
  fulfillmentGraphQlApi: { endpoint: '', type: 'api.fulfillment-graphql-api' }
};

export class Environments {
  static getUrl(environment: environments): string {
    const data = environmentEndpoints[environment];
    return Configuration.get(data.type) + data.endpoint;
  }

  static getApiKey(path: string): string {
    return Configuration.get(path);
  }

  static getUrlAsync(environment: environments): Observable<string> {
    const data = environmentEndpoints[environment];
    return Configuration.getAsync(data.type).pipe(map((url) => url + data.endpoint));
  }

  static getEnvironment(): string {
    return Configuration.get('environment');
  }

  static getEnvironmentAsync(): Observable<string> {
    return Configuration.getAsync('environment');
  }

  static getNewGatwayUrlBasedonEnv(gateway): string {

    console.log('***Current Env  ', Environments.getEnvironment());

/*     const isEnvDevOrPr = Environments.getEnvironment() === 'dev' || Environments.getEnvironment() === 'pr';

    const url:any = 
    (isEnvDevOrPr ? Environments.getUrl(<environments>`${gateway}New`): Environments.getUrl(gateway)); */

    const url = Environments.getUrl(gateway);
    console.log('***gegatewayEndpoint Url  ', url);

    return url;
  }

  static getAppUrl(name:string): string {
    return Configuration.get(name);
  }
}
